import {
    buildListParams,
    getListData,
    getTotalRecords,
    handleListDeleteIconMouseEnter,
    handleListIconMouseEnter,
    handleListIconMouseLeave,
    listStyles,
    loadStoredJson,
    removeStoredKeys,
    saveStoredValue
} from 'lib/listUtils';
import {
    Button,
    Card,
    CardContent,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Input,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    TextField,
    Tooltip
} from '@material-ui/core';
import {
    BackspaceOutlined,
    DeleteForeverOutlined,
    EditTwoTone,
    LockOutlined,
    LockOpenOutlined,
    Search,
    VisibilityOutlined
} from '@material-ui/icons';
import theme from 'theme';
import api from 'services/api';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import { safeSetState } from 'lib/reactUtils';
import { getApiErrorMessage } from 'lib/formUtils';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { ATEND_SAC_ABERTO, ATEND_SAC_ENCERRADO } from 'consts';
import { AlertInformation, DeleteConfirmationModal } from 'components';

class AtendimentoSacList extends Component {
    state = {
        searchFilter: loadStoredJson('atendimentosacSearchFilter', {
            idatendimento: '',
            nroreservacli: '',
            fantasia: '',
            nomespax: '',
            datainicio: '',
            datafinal: '',
            periodo: 0,
            situacaoFilter: ATEND_SAC_ABERTO
        }),
        atendimentos: [],
        open: false,
        openAlert: false,
        messageAlert: '',
        selectedId: null,
        selectedDesc: null,
        totalItems: 0,
        page: Number(sessionStorage.getItem('atendimentosacPage')) || 0,
        rowsPerPage: Number(sessionStorage.getItem('atendimentosacRowsPerPage')) || 10,
        openDescritivo: false,
        descritivo: '',
        atendimentoDescritivo: null,
        acaoDescritivo: null
    };

    estilo = listStyles;

    _isMounted = false;

    handleIconMouseEnter = handleListIconMouseEnter;
    handleIconMouseLeave = handleListIconMouseLeave;
    handleDeleteIconMouseEnter = handleListDeleteIconMouseEnter;
    safeSetState = safeSetState;

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this._isMounted = true;
        this.loadAtendimentos();
    };

    /* Paginação */
    componentDidUpdate(prevProps, prevState) {
        const { page, rowsPerPage, searchFilter } = this.state;

        // persiste os filtros e a paginação no sessionStorage
        if (prevState.searchFilter !== searchFilter) {
            saveStoredValue('atendimentosacSearchFilter', searchFilter);
        }

        if (prevState.page !== page) {
            saveStoredValue('atendimentosacPage', page);
        }

        if (prevState.rowsPerPage !== rowsPerPage) {
            saveStoredValue('atendimentosacRowsPerPage', rowsPerPage);
        }
    };

    /* Limpa os filtros e a paginação ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;

        removeStoredKeys([
            'atendimentosacSearchFilter',
            'atendimentosacPage',
            'atendimentosacRowsPerPage'
        ]);
    };

    /* Carrega os atendimentos SAC */
    loadAtendimentos = async () => {
        const { searchFilter, page, rowsPerPage } = this.state;

        const {
            datafinal,
            datainicio,
            fantasia,
            idatendimento,
            nomespax,
            nroreservacli,
            periodo,
            situacaoFilter
        } = searchFilter;

        const filtros = [
            {
                field: 'IDATENDIMENTO',
                value: idatendimento
            },
            {
                field: 'NRORESERVACLI',
                value: nroreservacli
            },
            {
                field: 'FANTASIA',
                value: fantasia,
                operator: '_like_'
            },
            {
                field: 'NOMESPAX',
                value: nomespax,
                operator: '_like_'
            }
        ];

        if (situacaoFilter && situacaoFilter !== 'T') {
            filtros.push({
                field: 'SITUACAO',
                value: situacaoFilter
            });
        }

        const params = buildListParams({
            page,
            rowsPerPage,
            filters: filtros
        });

        // o período (datainicio/datafinal/periodo) vai à parte
        let urlPeriodo = '';

        if (datainicio && datafinal) {
            urlPeriodo = `&datainicio=${datainicio}&datafinal=${datafinal}&periodo=${periodo}`;
        }

        try {
            const response = await api.get('/atendimentosac' + params + urlPeriodo);

            this.safeSetState({
                atendimentos: getListData(response),
                totalItems: getTotalRecords(response)
            });
        } catch (error) {
            console.error('Erro ao carregar os atendimentos SAC:', error);

            this.safeSetState({
                atendimentos: [],
                totalItems: 0
            });
        }
    };

    /* Muda a página */
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, this.loadAtendimentos);
    };

    /* Muda a quantidade de retornos por página */
    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        }, this.loadAtendimentos);
    };

    /* Deleta o atendimento SAC */
    handleDelete = async (id) => {
        try {
            const response = await api.delete(`/atendimentosac/${id}`);

            // verifica se a exclusão foi bem-sucedida
            if (response.status === 200) {
                this.handleClose();
                this.loadAtendimentos();
            }
        } catch (error) {
            this.handleClose();

            this.handleOpenAlert(getApiErrorMessage(error, 'Erro ao excluir o atendimento SAC!'));
        }
    };

    /* Confirma a exclusão */
    handleConfirmDelete = () => {
        const { selectedId } = this.state;

        this.handleDelete(selectedId);
    };

    /* Abre a janela de confirmação para a exclusão */
    handleOpen = (idatendimento) => {
        this.setState({
            open: true,
            selectedId: idatendimento,
            selectedDesc: idatendimento
        });
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de confirmação da exclusão */
    handleClose = () => {
        this.setState({
            open: false,
            selectedId: null,
            selectedDesc: ''
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Abre a janela pra informar o descritivo de encerramento / reabertura */
    onClickAbrirDescritivo = (atendimento, acao) => {
        this.setState({
            openDescritivo: true,
            descritivo: '',
            atendimentoDescritivo: atendimento,
            acaoDescritivo: acao
        });
    };

    /* Fecha a janela de descritivo */
    onCloseDescritivo = () => {
        this.setState({
            openDescritivo: false,
            descritivo: '',
            atendimentoDescritivo: null,
            acaoDescritivo: null
        });
    };

    /* Altera o texto do descritivo */
    onChangeDescritivo = (event) => {
        this.setState({ descritivo: event.target.value });
    };

    /* Confirma o encerramento ou a reabertura do atendimento */
    onConfirmaDescritivo = async () => {
        const { acaoDescritivo, atendimentoDescritivo, descritivo } = this.state;

        if (!descritivo || !descritivo.trim()) {
            this.handleOpenAlert('Obrigatório informar descritivo do registro!');

            return;
        }

        try {
            await api.post(
                `/atendimentosac/${atendimentoDescritivo.idatendimento}/${acaoDescritivo}`,
                { descritivo }
            );

            this.onCloseDescritivo();
            this.loadAtendimentos();
        } catch (error) {
            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    acaoDescritivo === 'encerrar'
                        ? 'Erro ao encerrar o atendimento!' : 'Erro ao reabrir o atendimento!'
                )
            );
        }
    };

    /* Pesquisa os filtros na tela */
    onChangeSearch = (event) => {
        const { name, value } = event.target;

        const searchFilter = {
            ...this.state.searchFilter,
            [name]: (typeof value === 'string') ? value.toUpperCase() : value
        };

        this.setState({
            searchFilter,
            page: 0
        });
    };

    /* Limpa os filtros da tela */
    limpaFiltros = () => {
        const searchFilter = {
            idatendimento: '',
            nroreservacli: '',
            fantasia: '',
            nomespax: '',
            datainicio: '',
            datafinal: '',
            periodo: 0,
            situacaoFilter: ATEND_SAC_ABERTO
        };

        this.setState({
            searchFilter,
            page: 0
        }, this.loadAtendimentos);
    };

    render() {
        const {
            acaoDescritivo,
            atendimentos,
            descritivo,
            messageAlert,
            open,
            openAlert,
            openDescritivo,
            page,
            rowsPerPage,
            searchFilter,
            selectedDesc,
            selectedId,
            totalItems
        } = this.state;

        const {
            actionIcon,
            addButton,
            filterPaper,
            iconGroup
        } = this.estilo;

        const basePath = this.props.match?.url || '';

        return (
            <div style={this.estilo}>
                <Paper
                    style={{
                        ...filterPaper,
                        width: '100%'
                    }}
                >
                    <Input
                        autoFocus
                        id="idatendimento"
                        name="idatendimento"
                        onChange={this.onChangeSearch}
                        placeholder="Atendimento"
                        value={searchFilter.idatendimento}
                        style={{
                            flex: '0 1 140px',
                            minWidth: 140
                        }}
                    />

                    <Input
                        id="nroreservacli"
                        name="nroreservacli"
                        onChange={this.onChangeSearch}
                        placeholder="Nro. reserva cliente"
                        value={searchFilter.nroreservacli}
                        style={{
                            flex: '0 1 180px',
                            minWidth: 180
                        }}
                    />

                    <Select
                        id="situacaoFilter"
                        name="situacaoFilter"
                        value={searchFilter.situacaoFilter || ''}
                        onChange={this.onChangeSearch}
                        style={{
                            flex: '0 1 120px',
                            minWidth: 120,
                            textAlign: 'center'
                        }}
                    >
                        <MenuItem
                            value={ATEND_SAC_ABERTO}
                            style={{ justifyContent: 'center' }}
                        >
                            Abertas
                        </MenuItem>

                        <MenuItem
                            value={ATEND_SAC_ENCERRADO}
                            style={{ justifyContent: 'center' }}
                        >
                            Encerradas
                        </MenuItem>

                        <MenuItem
                            value={'T'}
                            style={{ justifyContent: 'center' }}
                        >
                            Todas
                        </MenuItem>
                    </Select>

                    <span style={iconGroup}>
                        <Tooltip title="Procurar">
                            <Search
                                onClick={this.loadAtendimentos}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>

                        <Tooltip title="Limpar">
                            <BackspaceOutlined
                                onClick={this.limpaFiltros}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>
                    </span>

                    <div style={{ flex: 1 }} />

                    <Button
                        component={Link}
                        to={`${basePath}/novo`}
                        variant="contained"
                        color="primary"
                        style={addButton}
                    >
                        Novo
                    </Button>
                </Paper>

                <br />

                <Paper
                    style={{
                        ...filterPaper,
                        width: '100%'
                    }}
                >
                    <Select
                        id="periodo"
                        name="periodo"
                        value={searchFilter.periodo}
                        onChange={this.onChangeSearch}
                        style={{
                            flex: '0 1 140px',
                            minWidth: 140
                        }}
                    >
                        <MenuItem value={0}>
                            Período de IN
                        </MenuItem>

                        <MenuItem value={1}>
                            Período de OUT
                        </MenuItem>

                        <MenuItem value={2}>
                            Período de registro
                        </MenuItem>
                    </Select>

                    <Input
                        id="datainicio"
                        name="datainicio"
                        type="date"
                        value={searchFilter.datainicio || ''}
                        onChange={this.onChangeSearch}
                        style={{
                            flex: '0 1 130px',
                            minWidth: 130
                        }}
                    />

                    <span>a</span>

                    <Input
                        id="datafinal"
                        name="datafinal"
                        type="date"
                        value={searchFilter.datafinal || ''}
                        onChange={this.onChangeSearch}
                        style={{
                            flex: '0 1 130px',
                            minWidth: 130
                        }}
                    />

                    <Input
                        id="fantasia"
                        name="fantasia"
                        onChange={this.onChangeSearch}
                        placeholder="Hotel"
                        value={searchFilter.fantasia}
                        style={{
                            flex: '0 1 200px',
                            minWidth: 200
                        }}
                    />

                    <Input
                        id="nomespax"
                        name="nomespax"
                        onChange={this.onChangeSearch}
                        placeholder="Nome pax"
                        value={searchFilter.nomespax}
                        style={{
                            flex: '0 1 160px',
                            minWidth: 160
                        }}
                    />
                </Paper>

                <br />

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Atendimento</TableCell>

                                            <TableCell align="center">Res. Cliente</TableCell>

                                            <TableCell align="center">Hotel</TableCell>

                                            <TableCell align="center">Pax</TableCell>

                                            <TableCell align="center">Situação</TableCell>

                                            <TableCell align="center">Ações</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {atendimentos.length === 0 && (
                                            <TableRow>
                                                <TableCell
                                                    align="center"
                                                    colSpan={6}
                                                >
                                                    Nenhum atendimento SAC encontrado
                                                </TableCell>
                                            </TableRow>
                                        )}

                                        {atendimentos.map(atendimento => {
                                            const isEncerrado = atendimento.situacao === ATEND_SAC_ENCERRADO;

                                            return (
                                                <TableRow
                                                    hover
                                                    key={atendimento.idatendimento}
                                                >
                                                    <TableCell align="center">
                                                        {atendimento.idatendimento}
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        {atendimento.nroreservacli}
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        {atendimento.nomehotel}
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        {atendimento.nomespax}
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        {isEncerrado ? 'Encerrado' : 'Aberto'}
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        <span style={iconGroup}>
                                                            <Tooltip title="Editar">
                                                                <Link to={`${basePath}/${atendimento.idatendimento}`}>
                                                                    <EditTwoTone
                                                                        onMouseEnter={this.handleIconMouseEnter}
                                                                        onMouseLeave={this.handleIconMouseLeave}
                                                                        style={actionIcon}
                                                                    />
                                                                </Link>
                                                            </Tooltip>

                                                            <Tooltip title="Visualizar">
                                                                <Link to={`${basePath}/${atendimento.idatendimento}/view`}>
                                                                    <VisibilityOutlined
                                                                        onMouseEnter={this.handleIconMouseEnter}
                                                                        onMouseLeave={this.handleIconMouseLeave}
                                                                        style={actionIcon}
                                                                    />
                                                                </Link>
                                                            </Tooltip>

                                                            {isEncerrado ? (
                                                                <Tooltip title="Reabrir">
                                                                    <LockOpenOutlined
                                                                        onClick={() => this.onClickAbrirDescritivo(atendimento, 'reabrir')}
                                                                        onMouseEnter={this.handleIconMouseEnter}
                                                                        onMouseLeave={this.handleIconMouseLeave}
                                                                        style={actionIcon}
                                                                    />
                                                                </Tooltip>
                                                            ) : (
                                                                <Tooltip title="Encerrar">
                                                                    <LockOutlined
                                                                        onClick={() => this.onClickAbrirDescritivo(atendimento, 'encerrar')}
                                                                        onMouseEnter={this.handleIconMouseEnter}
                                                                        onMouseLeave={this.handleIconMouseLeave}
                                                                        style={actionIcon}
                                                                    />
                                                                </Tooltip>
                                                            )}

                                                            <Tooltip title="Excluir">
                                                                <DeleteForeverOutlined
                                                                    onClick={() => this.handleOpen(atendimento.idatendimento)}
                                                                    onMouseEnter={this.handleDeleteIconMouseEnter}
                                                                    onMouseLeave={this.handleIconMouseLeave}
                                                                    style={actionIcon}
                                                                />
                                                            </Tooltip>
                                                        </span>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>

                        <TablePagination
                            component="div"
                            count={totalItems}
                            onPageChange={this.handleChangePage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            rowsPerPageOptions={[10, 50, 100, 200]}
                            labelRowsPerPage="Registros por página"
                        />
                    </CardContent>
                </Card>

                <DeleteConfirmationModal
                    open={open}
                    itemId={selectedId}
                    message={`Confirma exclusão do atendimento SAC ${selectedDesc || ''}?`}
                    handleClose={this.handleClose}
                    handleDelete={this.handleConfirmDelete}
                />

                <Dialog
                    open={openDescritivo}
                    onClose={this.onCloseDescritivo}
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle>
                        {acaoDescritivo === 'encerrar'
                            ? 'Informe uma descrição para o encerramento'
                            : 'Informe uma descrição para a reabertura'
                        }
                    </DialogTitle>

                    <DialogContent>
                        <TextField
                            autoFocus
                            multiline
                            minRows={4}
                            variant="outlined"
                            value={descritivo}
                            onChange={this.onChangeDescritivo}
                            fullWidth
                        />
                    </DialogContent>

                    <DialogActions>
                        <Button
                            color="secondary"
                            onClick={this.onCloseDescritivo}
                        >
                            Cancelar
                        </Button>

                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.onConfirmaDescritivo}
                        >
                            Confirmar
                        </Button>
                    </DialogActions>
                </Dialog>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

export default AtendimentoSacList;